// Phase 6b / deferred-item 4.12 lazy fallback. Mirror of the backend
// helper at backend/src/utils/resolveComboIntensity.js. Spec:
// docs/superpowers/archive/specs/2026-05-18-spray-intensity-per-combo-design.md
//
// Resolves a combo's effective intensity by reading its own value first,
// then lazily falling back to the parent session's deprecated value.
// A null/undefined combo short-circuits to null — there is nothing to
// resolve for a missing combo.
//
// Marked for removal alongside SpraySession.intensityLevel in the cleanup
// PR for deferred-item 3.10.

import type { IntensityLabel } from '../services/sprayService';

export function resolveComboIntensity(
  combo: { intensityLevel?: IntensityLabel | null } | null | undefined,
  parentSession: { intensityLevel?: IntensityLabel | null } | null | undefined,
): IntensityLabel | null {
  if (!combo) return null;
  if (combo.intensityLevel) return combo.intensityLevel;
  if (parentSession && parentSession.intensityLevel) return parentSession.intensityLevel;
  return null;
}
